import { render, staticRenderFns } from "./bill-form-paid.vue?vue&type=template&id=163447f9&scoped=true"
import script from "./bill-form-paid.vue?vue&type=script&lang=js"
export * from "./bill-form-paid.vue?vue&type=script&lang=js"
import style0 from "./bill-form-paid.vue?vue&type=style&index=0&id=163447f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163447f9",
  null
  
)

export default component.exports